/* eslint-disable @stencil-community/required-jsdoc */
import { isEmpty } from '@springbokagency/stencil-base';
import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'efb-title-bar',
  styleUrl: 'title-bar.scss',
  shadow: true,
})
export class EfbTitleBar {
  /**
   * Props
   */

  @Prop() text: string;

  @Prop() tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span';

  @Prop() bottomMargin?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';

  @Prop() variant?: 'purple' | 'pink' | 'blue' = 'purple';

  /**
   * Render
   */

  render() {
    const TagType = this.tag;

    return (
      <Host>
        <TagType
          class={`title-bar
          ${!isEmpty(this.bottomMargin) ? `has-${this.bottomMargin}-margin` : ''}
          is-${this.variant}-variant`}
          innerHTML={this.text}
        />
      </Host>
    );
  }
}
